import React from 'react';

// my Img
import myImg from './images/my-img.webp';

// down arrow
import arrow from './images/arrow.png';

const Header = () => {
    return (<>
        <header id="home">
            <section>
                <small>Hi, I’m Yahia,</small>
                <h1>Front-End Developer</h1>
                <a className='btn' href='https://api.whatsapp.com/send/?phone=201097741207&text&type=phone_number&app_absent=0'>Contact Me</a>
            </section>
            <section>
                <div className='my-img'>
                    <img src={myImg} alt="my-img"></img>
                </div>
            </section>
        </header>
        <section className='scroll-down'>
            <small>scroll down</small>
            <img src={arrow} alt="arrow" className='arrow'/>
        </section>
    </>);
}

export default Header;